// extracted by mini-css-extract-plugin
module.exports = {"dualGrid":"filtersLayout_dualGrid__2xqGW","flexColumn":"filtersLayout_flexColumn__wAXHJ"};